export default __webpack_public_path__ + "static/Year1890a-c2d40b29fb908f68bc478819a81ec8f6.png";